import React from 'react';
import { ArrowDown, Sparkles } from 'lucide-react';
import { personalInfo } from '../data/mock';

export const Hero = () => {
  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="home" className="relative min-h-screen flex items-center justify-center overflow-hidden bg-background">
      {/* Animated Background Elements */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-1/4 left-1/4 w-[500px] h-[500px] bg-purple-600/30 dark:bg-purple-600/20 rounded-full blur-3xl transform-gpu pointer-events-none"></div>
        <div className="absolute bottom-1/4 right-1/4 w-[500px] h-[500px] bg-yellow-400/20 dark:bg-yellow-500/10 rounded-full blur-3xl transform-gpu pointer-events-none"></div>
        <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[700px] h-[700px] bg-blue-400/10 dark:bg-transparent rounded-full blur-[100px] transform-gpu pointer-events-none"></div>
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[600px] h-[600px] border border-foreground/5 rounded-full pointer-events-none"></div>
        <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[500px] h-[500px] border border-purple-500/10 rounded-full pointer-events-none"></div>
      </div>

      {/* Abstract Rotating Element */}
      <div className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 w-[400px] h-[400px] opacity-20">
        <div className="relative w-full h-full md:animate-spin-slow">
          <div className="absolute inset-0 rounded-full border-2 border-purple-500/30"></div>
          <div className="absolute inset-8 rounded-full border-2 border-yellow-500/30"></div>
          <div className="absolute inset-16 rounded-full border-2 border-purple-500/30"></div>
        </div>
      </div>

      {/* Content */}
      <div className="relative z-10 container mx-auto px-6 lg:px-12 text-center pt-24 md:pt-0">
        <div className="inline-flex items-center gap-2 px-4 py-2 bg-purple-500/10 border border-purple-500/20 rounded-full mb-10 backdrop-blur-sm shadow-sm ring-1 ring-purple-500/5">
          <Sparkles size={16} className="text-yellow-600 dark:text-yellow-400" />
          <span className="text-sm text-foreground/70 font-light tracking-wide italic">Available for new projects</span>
        </div>

        <h2 className="text-5xl md:text-7xl lg:text-8xl font-extralight text-foreground mb-6 tracking-tight leading-tight">
          {personalInfo.name.split(' ').map((word, index) => (
            <span key={index} className="block">
              {word}
              {index === 1 && <span className="text-yellow-600 dark:text-yellow-400 animate-pulse">.</span>}
            </span>
          ))}
        </h2>

        <div className="max-w-3xl mx-auto mb-12">
          <h1 className="text-sm min-[375px]:text-base sm:text-lg md:text-2xl text-purple-600 dark:text-purple-400 font-extrabold mb-3 tracking-wide drop-shadow-sm">
            {personalInfo.title}
          </h1>
          <p className="text-xs min-[375px]:text-sm sm:text-base text-foreground/60 font-bold leading-relaxed">
            {personalInfo.tagline}
          </p>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3 mb-10 md:mb-16">
          <button
            onClick={() => scrollToSection('contact')}
            className="px-8 py-4 bg-gradient-to-r from-purple-600 to-purple-800 hover:from-yellow-600 hover:to-yellow-700 text-white rounded-full transition-all duration-300 transform hover:scale-105 hover:shadow-2xl hover:shadow-purple-500/40 font-semibold tracking-wide"
          >
            Let's Work Together
          </button>
          <button
            onClick={() => scrollToSection('services')}
            className="px-8 py-4 border border-foreground/20 text-foreground rounded-full hover:bg-foreground/5 hover:border-yellow-600/50 dark:hover:border-yellow-400/50 transition-all duration-300 transform hover:scale-105 font-medium tracking-wide"
          >
            View Services
          </button>
        </div>

        {/* Scroll Indicator */}
        <button
          onClick={() => scrollToSection('about')}
          className="inline-flex flex-col items-center gap-2 text-foreground/40 hover:text-yellow-600 dark:hover:text-yellow-400 transition-colors duration-300 group"
        >
          <span className="text-xs font-light tracking-widest uppercase mb-1 text-foreground dark:text-foreground/40">Scroll to explore</span>
          <ArrowDown size={20} className="animate-bounce text-purple-600 dark:text-purple-400" />
        </button>
      </div>
    </section>
  );
};
